import { Flex, Text, Heading, Box} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { IJobsheet } from "../../../../interfaces/jobsheets/IJobsheet";
import { IWipLine, LinePricingType, WiplineStatus } from "../../../../interfaces/jobsheets/IWipline";
import * as webHelpers from "../../../../helpers/WebHelpers";
import IProduct from "../../../../interfaces/products/IProduct";

interface IWipQuestions {
    wipline: IWipLine,
    questions: IQuestionContent[],
    is_non_customer_facing: boolean | undefined
}

interface IQuestionContent {
    answer: string,
    question: string,
    type: string,
}

interface IProps {
    jobsheet: IJobsheet,
    appointmentWipLines: IWipLine[],
    otherWipLines?: IWipLine[],
    showCleardownPlan: boolean
}

export const DescriptionOfWorks = ({jobsheet, appointmentWipLines, otherWipLines, showCleardownPlan}: IProps) => {
    const [wipApptQuestions, setWipApptQuestions] = useState<IWipQuestions[]>([]);
    const [wipOtherQuestions, setWipOtherQuestions] = useState<IWipQuestions[]>([]);

    const getFluidJson = async (body: any) => {
        return await webHelpers.postAsync<any, IQuestionContent[]>(
            "/api/core/universal/fluid/responses/", body, "sales"
        )
    }

    useEffect(() => {
        let apptQs: IWipQuestions[] = [];
        let otherQs: IWipQuestions[] = [];

        if (showCleardownPlan) {
            appointmentWipLines.forEach((wipline: IWipLine) => {
                let wipQ: IWipQuestions = {
                    wipline: wipline,
                    questions: [],
                    is_non_customer_facing: wipline.pricing_type == LinePricingType.Subordinate
                }

                webHelpers.getAsync<any>("/api/sales/work/wip/cleardownpath?id=" + wipline.id).then((response) => {
                    if (response !== null) {
                        getFluidJson(response).then((answers) => {
                            wipQ.questions = answers;

                            webHelpers.getAsync<IProduct>(
                                "/api/sales/products/catalogue/item/get?id=" + wipline.line_data.product_id,
                                //undefined, Product // Comment this line out when running server
                            ).then((res) => {
                                wipQ.is_non_customer_facing = wipQ.is_non_customer_facing || res?.calculator.is_non_customer_faciing
                            })
                        });
                    }
                    else {
                        console.log(" no cleardown")
                    }
                }).catch((error) => {
                    console.error("We couldn't get the cleardown path, does it exist?")
                }).finally(() => {
                    apptQs.push(wipQ);
                    setWipApptQuestions(apptQs);
                });
            });

            otherWipLines?.forEach((wipline: IWipLine) => {
                let wipQ: IWipQuestions = {
                    wipline: wipline,
                    questions: [],
                    is_non_customer_facing: wipline.pricing_type == LinePricingType.Subordinate
                }

                webHelpers.getAsync<any>("/api/sales/work/wip/cleardownpath?id=" + wipline.id).then((response) => {
                    if (response !== null) {
                        getFluidJson(response).then((answers) => {
                            wipQ.questions = answers;

                            webHelpers.getAsync<IProduct>(
                                "/api/sales/products/catalogue/item/get?id=" + wipline.line_data.product_id,
                                //undefined, Product // Comment this line out when running server
                            ).then((res) => {
                                wipQ.is_non_customer_facing = wipQ.is_non_customer_facing || res?.calculator.is_non_customer_faciing
                            })
                        });
                    }
                }).catch((error) => {
                    console.error("We couldn't get the cleardown path, does it exist?")
                }).finally(() => {
                    otherQs.push(wipQ);
                    setWipOtherQuestions(otherQs);
                });
            });

        } else {
            appointmentWipLines.forEach((wipline: IWipLine) => {
                let wipQ: IWipQuestions = {
                    wipline: wipline,
                    questions: [],
                    is_non_customer_facing: wipline.pricing_type == LinePricingType.Subordinate
                }

                webHelpers.getAsync<IProduct>(
                    "/api/sales/products/catalogue/item/get?id=" + wipline.line_data.product_id,
                    //undefined, Product // Comment this line out when running server
                ).then((res) => {
                    console.log("product = ", res)
                    wipQ.is_non_customer_facing = wipQ.is_non_customer_facing || res?.calculator.is_non_customer_faciing
                }).catch((error) => {
                    console.error("Unable to get product")
                }).finally(() => {
                    apptQs.push(wipQ);
                    setWipApptQuestions(apptQs);
                });
            });

            otherWipLines?.forEach((wipline: IWipLine) => {
                let wipQ: IWipQuestions = {
                    wipline: wipline,
                    questions: [],
                    is_non_customer_facing: wipline.pricing_type == LinePricingType.Subordinate
                }

                webHelpers.getAsync<IProduct>(
                    "/api/sales/products/catalogue/item/get?id=" + wipline.line_data.product_id,
                    //undefined, Product // Comment this line out when running server
                ).then((res) => {
                    wipQ.is_non_customer_facing = wipQ.is_non_customer_facing || res?.calculator.is_non_customer_faciing
                }).catch((error) => {
                    console.error("Unable to get product")
                }).finally(() => {
                    otherQs.push(wipQ);
                    setWipOtherQuestions(otherQs);
                });

            });
        }
        
    }, [appointmentWipLines, otherWipLines, showCleardownPlan]);

    return(
        //put stuff here
        <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' h='full'>
            <Flex direction='column' w='full' h='max'>
                <Heading size='md' color='var(--Able-blue)' borderBottom='2px' borderColor='gray.200' m={2} p={2}>Description of Works</Heading>
                    {(otherWipLines?.length ?? 0) > 0 && <Heading size='18px' pl={{base: 2, md: 4}}>Current Appointment:</Heading>}
                    {wipApptQuestions.map((item: IWipQuestions, index: number) =>
                        // <Flex w='full' alignItems='center' key={"Wip"+index}>

                            <Box w='full' p={2} px={{ base: 2, md: 4 }}>
                                <Text>{item.wipline.quantity}&#215; {item.wipline.name}</Text>
                                {jobsheet.value_autocalc && (item.is_non_customer_facing === false || item.is_non_customer_facing === undefined) && item.wipline.price_description !== "Refer to labour line" &&
                                    <Text mb={1}><Text as='span' fontWeight='semibold'>Pricing: </Text>{item.wipline.price_description}</Text>
                                }

                                {showCleardownPlan &&
                                    item.questions.map((element: IQuestionContent) =>
                                        <Flex pl={2} mb={2} direction='column' key={crypto.randomUUID()}>
                                            <Text fontSize='md' as={"b"}>Q: {element.question}</Text>
                                            <Text fontSize='md' as={"i"}>A: {element.answer}</Text>
                                        </Flex>
                                    )
                                }
                            </Box>

                        // </Flex>
                    )}

                    {(otherWipLines?.length ?? 0) > 0 && <Heading size='18px' pl={{base: 2, md:4}} mt={4}>Other Works:</Heading>}
                    {wipOtherQuestions.map((item: IWipQuestions, index: number) =>
                        <Flex w='full' alignItems='center' key={index}>
                            <Box w='full' p={2} px={{ base: 2, md: 4 }}>
                                <Text>{item.wipline.quantity}&#215; {item.wipline.name}</Text>
                                {jobsheet.value_autocalc && (item.is_non_customer_facing === false || item.is_non_customer_facing === undefined) && item.wipline.price_description !== "Refer to labour line" &&
                                    <Text mb={1}><Text as='span' fontWeight='semibold'>Pricing: </Text>{item.wipline.price_description}</Text>
                                }
                                
                                {showCleardownPlan &&
                                    item.questions.map((element: IQuestionContent) =>
                                        <Flex pl={2} mb={2} direction='column' key={crypto.randomUUID()}>
                                            <Text fontSize='md' as={"b"}>Q: {element.question}</Text>
                                            <Text fontSize='md' as={"i"}>A: {element.answer}</Text>
                                        </Flex>
                                    )
                                }
                            </Box>
                        </Flex>
                    )}
            </Flex>
        </Box>
    )
}
